import React, { useState } from 'react'
import Button from 'components/button'
import { IApiKeyConfig } from 'types'
import api from 'helpers/api'
import { useAuth } from 'hooks/auth'
import { useApplicationStore } from 'hooks/application'
import IntegrationCard from 'views/integrations/components/IntegrationCard'
import ApiKeyModal from 'views/integrations/components/ApiKeyModal'

interface ApiKeyConnectionProps {
  provider: string
  logo: string
  connected: boolean
  connectingAccount: boolean
  apiKeyConfig: IApiKeyConfig
  disconnectAccount: (provider: string) => void
}

const ApiKeyConnection: React.FC<ApiKeyConnectionProps> = ({ apiKeyConfig, ...cardProps }) => {
  const [saving, setSaving] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const { updateUser } = useAuth()
  const { displayErrorMessage, setSnackbarMessage } = useApplicationStore()

  const handleConnect = async (credentials: Record<string, string>) => {
    setSaving(true)
    try {
      const response = await api.saveApiKey(cardProps.provider, credentials)
      updateUser(response.data)
      setSnackbarMessage({ status: 'success', message: 'Account connected successfully' })
      setModalOpen(false)
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Your account couldn't be connected. Check the details you entered and try again."
      displayErrorMessage(err instanceof Error ? err : message)
    }
    setSaving(false)
  }

  return (
    <IntegrationCard {...cardProps} connectingAccount={cardProps.connectingAccount || saving}>
      <Button onClick={() => setModalOpen(true)} disabled={saving || cardProps.connectingAccount}>
        Connect
      </Button>
      <ApiKeyModal
        open={modalOpen}
        setOpen={setModalOpen}
        fields={apiKeyConfig.fields}
        onSubmit={handleConnect}
        saving={saving}
      />
    </IntegrationCard>
  )
}

export default ApiKeyConnection
